 // product page ugc video slider
function waitForSwiper(trigger) {
  var interval = setInterval(function () {
    if (typeof Swiper != "undefined") {
      clearInterval(interval);
      trigger();
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}
function addScript() {
  var swiperScript = document.createElement("script");
  swiperScript.src =
    "https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.7/js/swiper.min.js";
  document.getElementsByTagName("head")[0].appendChild(swiperScript);
}

    egswiperTiktok = new Swiper(".eg-video-section .swiper-container", {
      // Optional parameters
      direction: "horizontal",
      spaceBetween: 20,
      slidesPerView: 5,
      roundLengths: true,
      loop: true,
      arrow: true,
      breakpoints: {
        1199: {
          slidesPerView: 5,
        },
        991: {
          slidesPerView: 4.3,
        },
        800: {
          slidesPerView: 3.6,
          arrow: false,
        },
        500: {
          slidesPerView: 2.2,
          centeredSlides: true,
        },
        320: {
          slidesPerView: 1.7,
          centeredSlides: true,
        },
      },
      pagination: {
        el: ".slider__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });


// pdp Product Details TAb
$(document).ready(function(){
  var tabWrapper = $('#tab-block'),
      tabMnu = tabWrapper.find('.tab-mnu  li'),
      tabContent = tabWrapper.find('.tab-cont > .tab-pane');
  
  // tabContent.not(':first-child').hide();
  
  tabMnu.each(function(i){
    $(this).attr('data-tab','tab'+i);
  });
  tabContent.each(function(i){
    $(this).attr('data-tab','tab'+i);
  });
  
  tabMnu.click(function(){
    var tabData = $(this).data('tab');
    tabWrapper.find(tabContent).hide();
    tabWrapper.find(tabContent).filter('[data-tab='+tabData+']').show(); 
  });
  
  $('.tab-mnu > li').click(function(){
    var before = $('.tab-mnu li.active');
    before.removeClass('active');
    $(this).addClass('active');
   });
  
});

const upsellAddToCart = (event) => {
    const id = event.target.getAttribute("data-vid");
    const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    
    let items = [{ id: id, quantity: 1 }];
    let formData = {
      items: items,
      sections: cart ? Array.from(cart.getSectionsToRender()).map(section => section.id) : [],
      sections_url: window.location.pathname,
    };

    fetch(`${routes.cart_add_url}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: id,
            errors: response.description,
            message: response.message,
          });
          return;
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: id,
        });
        cart.renderContents(response);
      })
      .catch(error => console.error(error));
}

const updateUpsellBtnEvents = () => {
  const upsellButtons = document.querySelectorAll(".upsell-add-cart");
  if(upsellButtons.length > 0){
    upsellButtons.forEach((el) => {
      el.addEventListener("click",upsellAddToCart);
    })
  }
  
  const subscribeBoxes = document.querySelectorAll(".subscribe-box");
  
  if(subscribeBoxes.length > 0){
    subscribeBoxes.forEach((el) => {
      el.addEventListener("click",()=>{
        
          const id = el.dataset.itemkey;
          const qty = +el.dataset.itemqty;
          const line = el.dataset.index;
          const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
          cartItems.enableLoading(line);
          let formData = {
            id: id, 
            quantity: qty,
            sections: cart ? Array.from(cart.getSectionsToRender()).map(section => section.id) : [],
            sections_url: window.location.pathname,
          };
      
          fetch(`${routes.cart_change_url}.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          })
            .then(response => response.json())
            .then(response => {
              const parsedState = response;
              if (response.status) {
                
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: id });
                return;
              } else if (!cart) {
                window.location = window.routes.cart_url;
                return;
              }
      
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: id });
              cart.renderContents(response);
            })
            .catch(error => console.error(error)).finally(() => {
              cartItems.disableLoading(line);
            });
      });
    })
  }
  const customPlanSelectors = document.querySelectorAll(".custom-subscribe-selling");
  if(customPlanSelectors.length > 0){
    customPlanSelectors.forEach((el) => {
      el.addEventListener("change",() => {
        
        const id = el.dataset.key;
        const qty = +el.dataset.qty;
        const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        const line = el.dataset.index;
        let selling_plan = el.value;
        const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        cartItems.enableLoading(line);
        let formData = {
          id: id, 
          quantity: qty,
          selling_plan:selling_plan,
          sections: cart ? Array.from(cart.getSectionsToRender()).map(section => section.id) : [],
          sections_url: window.location.pathname,
        }; 
        fetch(`${routes.cart_change_url}.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          })
            .then(response => response.json())
            .then(response => {
              const parsedState = response;
              if (response.status) {
                
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: id });
                return;
              } else if (!cart) {
                window.location = window.routes.cart_url;
                return;
              }
      
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: id });
              cart.renderContents(response);
            })
            .catch(error => console.error(error)).finally(() => {
              cartItems.disableLoading(line);
            });
        
      });
    });
  }
  const subscriptionCheckboxes = document.querySelectorAll(".custom-subscription-selection");
  if(subscriptionCheckboxes.length > 0){
    subscriptionCheckboxes.forEach((el) => {
      el.addEventListener("change",(evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        const parentElement = el.parentElement.closest(".card-body");
        if(el.checked){
          parentElement.querySelector(".custom-subscribe-selling")?.classList.remove("hidden");
          const id = el.dataset.key;
          const qty = +el.dataset.qty;
          const sellingid = el.dataset.sellingid;
          const currentplanid = el.dataset.currentplan;
          const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
          const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
          const line = el.dataset.index;
          cartItems.enableLoading(line);
          let selling_plan = null;
          if(el.checked){
            selling_plan = sellingid;
          }
        
          let formData = {
            id: id, 
            quantity: qty,
            selling_plan:selling_plan,
            sections: cart ? Array.from(cart.getSectionsToRender()).map(section => section.id) : [],
            sections_url: window.location.pathname,
          }; 
          fetch(`${routes.cart_change_url}.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(formData),
            })
            .then(response => response.json())
            .then(response => {
              const parsedState = response;
              if (response.status) {
                
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: id });
                return;
              } else if (!cart) {
                window.location = window.routes.cart_url;
                return;
              }
      
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: id });
              cart.renderContents(response);
            })
            .catch(error => console.error(error)).finally(() => {
              cartItems.disableLoading(line);
            });
        }else{
          parentElement.querySelector(".custom-subscribe-selling")?.classList.add("hidden");
          const id = el.dataset.key;
          const qty = +el.dataset.qty;
          const sellingid = el.dataset.sellingid;
          const currentplanid = el.dataset.currentplan;
          if(currentplanid == '0'){
            return;
          }
          const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
           const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
          const line = el.dataset.index;
          cartItems.enableLoading(line);
          let selling_plan = null;
          if(el.checked){
            selling_plan = sellingid;
          }
        
        let formData = {
          id: id, 
          quantity: qty,
          selling_plan:selling_plan,
          sections: cart ? Array.from(cart.getSectionsToRender()).map(section => section.id) : [],
          sections_url: window.location.pathname,
        }; 
        fetch(`${routes.cart_change_url}.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          })
          .then(response => response.json())
          .then(response => {
            const parsedState = response;
            if (response.status) {
              
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: id });
              return;
            } else if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
    
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: id });
            cart.renderContents(response);
          })
          .catch(error => console.error(error)).finally(() => {
            cartItems.disableLoading(line);
          });
        }
      });
    });
  }
}
document.addEventListener("DOMContentLoaded", function() {
  // product media slider
  var swiper = new Swiper(".mySwiper", {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
  });
  var swiper2 = new Swiper(".mySwiper2", {
    loop: true,
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  // review slider
  var swiper = new Swiper(".slider-review-block", {
    cssMode: true,
    arrow: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    mousewheel: true,
    keyboard: true,
  });
  // 
  var swiper = new Swiper(".collection-swiper", {
    slidesPerView: 3,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      991: {
        slidesPerView: 3,
      },
      749: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
});

subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
 setTimeout(updateUpsellBtnEvents,2000);
});
document.addEventListener("DrawerCartOpened", (evt) => {
  //setTimeout(updateUpsellBtnEvents,2000);
  updateUpsellBtnEvents();
});


function toggleDetails(summary) {
    let details = summary.parentElement;
    let content = details.querySelector(".accordion__content");

    if (!details.open) {
        content.style.display = "block"; 
        let height = content.scrollHeight + "px";
        content.style.maxHeight = height;
    } else {
        content.style.maxHeight = "0";
        setTimeout(() => {
            if (!details.open) content.style.display = "none";
        }, 1000);
    }
}

/*
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.header__inline-menu a').forEach(anchor => {
        anchor.addEventListener("click", function (event) {
            event.preventDefault();

            const targetId = this.getAttribute("href");
            if (targetId === "#" || targetId === "") return; // Prevent empty href issues

            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY;

                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        });
    });
}); */
$(document).ready(function () {
  $(".footer-link-list h4").click(function(){
    $(this).toggleClass("active");
    $(this).next('ul').toggleClass("active");
  });
});